var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5662_18890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 1.33333H12V0.666667C12 0.298667 11.702 0 11.3333 0C10.9647 0 10.6667 0.298667 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.298667 5.03467 0 4.66667 0C4.29867 0 4 0.298667 4 0.666667V1.33333H3.33333C1.49533 1.33333 0 2.82867 0 4.66667V12.6667C0 14.5047 1.49533 16 3.33333 16H8C8.368 16 8.66667 15.7013 8.66667 15.3333C8.66667 14.9653 8.368 14.6667 8 14.6667H3.33333C2.23067 14.6667 1.33333 13.7693 1.33333 12.6667V6.66667H14.6667V10.6667C14.6667 11.0347 14.9647 11.3333 15.3333 11.3333C15.702 11.3333 16 11.0347 16 10.6667V4.66667C16 2.82867 14.5047 1.33333 12.6667 1.33333ZM1.33333 5.33333V4.66667C1.33333 3.564 2.23067 2.66667 3.33333 2.66667H12.6667C13.7693 2.66667 14.6667 3.564 14.6667 4.66667V5.33333H1.33333ZM15.7767 13.9807C16.074 14.278 16.074 14.7607 15.7767 15.058L15.4287 15.458C15.0613 15.826 14.5773 16 14.0953 16C11.6193 16 8 12.5713 8 9.90467C8 9.42267 8.174 8.93867 8.542 8.57133L8.942 8.22333C9.23933 7.926 9.722 7.926 10.0193 8.22333L10.8247 9.09133C11.122 9.38867 11.122 9.87133 10.8247 10.1687L10.1413 10.8593C10.742 12.3553 11.7607 13.3327 13.1413 13.8593L13.832 13.176C14.1293 12.8787 14.612 12.8787 14.9093 13.176L15.7773 13.9813L15.7767 13.9807Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5662_18890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCall);
export default __webpack_public_path__ + "static/media/calendar-call.d3331c8aaeeacef200b1710d3dd76c9d.svg";
export { ForwardRef as ReactComponent };